module.exports = function() {
  return new Worker("/" + "sass-transpiler.5c09ff82.worker.js");
};